module.exports = __webpack_public_path__ + "img/example.aa323d05.gif";